import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalUpdate';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Codigo', accessor: 'code'},
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'Fecha creación', accessor: 'created_at' },
  { Header: 'Fecha actualización', accessor: 'updated_at' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  update: 'INCENTIVOS_TIPO_INCENTIVOS_UPDATE',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
};
export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index].cuota = value;
    setCuotas([...cuotas]);
  };
  async function loadCuotas() {
    setDataLoading(true);
    let response = await wsFindBy('sale/canal-incentivo');
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }
  async function updateCuota(id, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/canal-incentivo', id, { cuota: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      loadCuotas();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    loadCuotas();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas()}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => loadCuotas()}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions[permission.store]}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de canales de incentivos {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="canal_incentivo"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="sale/canal-incentivo"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas().then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  description: item.description,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  created_at: item.created_at,
                  updated_at: item.updated_at,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
